import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=204cff86&"
import script from "./ChatSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=204cff86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports